import api from "./api";

export async function getCommentsIndicator (id = '', type = 'comments') {
    return await api.get(`/indicators/${id}?with=${type}`)
}

export async function getCommentsGoals (id = '', type = 'comments') {
    return await api.get(`/goals/${id}?with=${type}`)
}

export async function getComments (type= '',username = '', mentions = '', currentPage = 1) {
    return await api.get(`/comments?username=${username}&mentions=${mentions}&with=indicator:id,titulo&paginate=true&currentPage=${currentPage}&sortDirection=desc`)
    //return await api.get(`/comments?whereHas=${type}`)
}

export async function getCommentsMentions (username = '', mentions = '') {
    return await api.get(`/comments?username=${username}&mentions=${mentions}&with=indicator:id,titulo&sortDirection=desc`)
        .then((response) =>  response.data)
}

export async function getAllComments (username = '', mentions = '', currentPage = 1) {
    return await api.get(`/comments?username=${username}&mentions=${mentions}&paginate=true&currentPage=${currentPage}&sortDirection=desc`)

}

export async function getCommentsById(id, type = '') {
    return await api.get(`/comments?indicator_id=${id}&type_input=${type}`)
        .then(response => response.data)
        .catch(error => {return error.response});
}

export function setComment (data) {
    return api.post('/comments', data)
        .then(response => response.data)
}

export function updateComment (id, data) {
    return api.put(`/comments/update/${id}`, data)
        .then(response => response.data)
}

// export function delComment (id) {
//     return api.delete(`/comments/${id}`)
//         .then(response => response.data)
//         .catch(error => {return error.response});
// }


export function delComment (id) {
    return api.delete(`/comments/${id}`)
        .then(response => response.data)
        .catch(error => {return error.response});
}
